import React, { useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

import { useStyles } from './styles';
import { useDownloadImagesGql } from '../../graphql/downloadImage';
import { useEnvironment, useSnackbar } from '../../../../../hooks';

interface IImageDownloadButtonProps {
  imageKey: string;
}

export const ImageDownloadButton = (props: IImageDownloadButtonProps) => {
  const { imageKey } = props;
  const { DEBUG } = useEnvironment();
  const classes = useStyles();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const { base64Data, errorDownloadImage, loadingDownloadImage, runDownloadImageGql } = useDownloadImagesGql();

  useEffect(() => {
    runDownloadImageGql({ variables: { imageKey } });
  }, []);

  useEffect(() => {
    if (errorDownloadImage) {
      if (DEBUG === 'TRUE') {
        const msg = errorDownloadImage;
        console.log(`Erro ao carregar dados! Error:(message: ${msg} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar a imagem. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorDownloadImage]);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `data:image/jpeg;base64,${base64Data}`;
    link.download = imageKey;
    link.click();
  };

  return (
    <>
      <Snackbar />
      {!loadingDownloadImage && (
        <IconButton
          className={classes.buttonImageDownload}
          aria-label="download picture"
          component="span"
          onClick={handleDownload}
        >
          <GetAppIcon />
        </IconButton>
      )}
    </>
  );
};
